import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const updateRole = (resource, id, { lotId, roleId, ...values }) => {
  return axios.put(`/api/${resource}/${id}/setup/lots/${lotId}/roles/${roleId}`, values);
};

export const useUpdateRole = (resource, id, onSuccess) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => updateRole(resource, id, values),
    onSuccess: () => {
      enqueueSnackbar('Role successfully updated', { variant: 'success' });
      onSuccess();
    },
    onError: (error) => {
      enqueueSnackbar(error?.response?.data?.description || error?.message || 'Some error occured', {
        variant: 'error',
      });
    },
  });
};
